import { render, staticRenderFns } from "./NumericData.vue?vue&type=template&id=5a337002&scoped=true&"
import script from "./NumericData.vue?vue&type=script&lang=js&"
export * from "./NumericData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a337002",
  null
  
)

export default component.exports